import {
  Auth,
  Response,
  ServerAdapter,
  ServerEndpoint,
  Token,
  Tokens,
  UsernamePasswordCredentials,
  AxiosAdapter,
  JwtTokenDecoder
} from 'auth-toolbox'

import { AxiosInstance } from 'axios'
import { Store } from 'vuex'
import router from '@/router'
import { Request } from 'auth-toolbox/src/auth-toolbox'

export interface LoginResponse {
  token: string
  refreshToken: string
}

class SymfonyLexikAdapter implements ServerAdapter<UsernamePasswordCredentials> {
  asLoginRequest (loginEndpoint: ServerEndpoint, credentials: UsernamePasswordCredentials): Request {
    const data = { username: credentials.username, password: credentials.password }

    return { ...loginEndpoint, data }
  }

  asLogoutRequest (logoutEndpoint: ServerEndpoint, refreshToken: Token): Request {
    const data = {
      refreshToken: refreshToken.value
    }

    return { ...logoutEndpoint, data }
  }

  asRenewRequest (renewEndpoint: ServerEndpoint, refreshToken: Token): Request {
    const data = {
      refreshToken: refreshToken.value
    }

    return { ...renewEndpoint, data }
  }

  getResponseTokens (response: Response): Tokens {
    const loginResponse: LoginResponse = response.data

    if (!loginResponse.token) {
      throw new Error('No access token found in response')
    }

    const tokens: Tokens = {
      access: { value: loginResponse.token }
    }

    if (loginResponse.refreshToken) {
      tokens.refresh = { value: loginResponse.refreshToken }
    }

    return tokens
  }

  setAccessToken (request: Request, accessToken: string): void {
    if (!request.headers) {
      request.headers = {}
    }
    request.headers.Authorization = 'Bearer ' + accessToken
  }

  accessTokenHasExpired (request: Request, response: Response): boolean {
    return (
      !!request.headers &&
      !!request.headers.Authorization &&
      response.status === 401 &&
      response.data.message === 'Expired JWT Token'
    )
  }

  refreshTokenHasExpired (request: Request, response: Response): boolean {
    return (
      !!request.headers &&
      !!request.headers.Authorization &&
      response.status === 401
    )
  }
}

export default function authFactory (axios: AxiosInstance, store: Store<any>) {
  const auth = new Auth(
    {
      loginEndpoint: { method: 'post', url: 'login-check' },
      renewEndpoint: { method: 'post', url: 'api/token/refresh' }
    },
    new SymfonyLexikAdapter(),
    new AxiosAdapter(axios),
    { accessTokenDecoder: new JwtTokenDecoder() }
  )

  const payload = auth.decodeAccessToken()
  store.commit('auth/setPayload', payload)

  auth.addListener({
    tokensChanged: <UsernamePasswordCredentials> (tokens: Tokens<UsernamePasswordCredentials>) => {
      const payload = auth.decodeAccessToken()
      store.commit('auth/setPayload', payload)
    },
    expired: () => {
      if (window.stop) {
        window.stop() // Annnule toutes les requêtes en cours. Non supporté sur IE.
      }
      router.push({ name: 'logout' }).catch()
    },
    logout: () => {
      if (window.stop) {
        window.stop() // Annnule toutes les requêtes en cours. Non supporté sur IE.
      }
    }
  })

  auth.usePersistentStorage = true
  return auth
}
